import { render, staticRenderFns } from "./GroupPackageItems.vue?vue&type=template&id=2c535a2e&scoped=true&"
import script from "./GroupPackageItems.vue?vue&type=script&lang=js&"
export * from "./GroupPackageItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c535a2e",
  null
  
)

export default component.exports